<template>
	<v-dialog v-model="isVisible" max-width="700">
		<p-card class="skill-selection">
			<span
				class="tw-p-2 tw-w-full tw-text-center text-lg tw-text-white skill-title tw-block tw-mb-4"
				>{{ CHOOSE_SKILLS_MESSAGE() }} ({{ selectedOptions.length }} /
				{{ pathOr(0, ['skills', 'length'], selectedSkillGroup) }})</span
			>
			<div class="tw-flex tw-gap-4 tw-items-center tw-py-4">
				<span class="tw-text-app-color-secondary">Seleccionar Competencias</span>
				<v-select
					solo
					class="custom-select"
					item-text="name"
					item-value="id"
					:items="skills"
					v-model="selectedSkillGroupId"
				></v-select>
			</div>
			<div class="skill-table">
				<div class="skill-table--row">
					<div></div>
					<div class="uppercase tw-text-app-color-primary">
						Competencias
					</div>
					<div class="uppercase tw-text-app-color-primary">definición</div>
				</div>
				<div
					v-for="(skill, index) in selectedSkillGroup.skills"
					:key="index"
					class="skill-table--row"
				>
					<div>
						<v-checkbox
							class="custom-checkbox tw-inline-block"
							@change="onCheckChange($event, skill)"
							color="primary"
							v-model="checkBoxModel[skill.id]"
						/>
					</div>
					<p class="tw-m-0">{{ skill.name }}</p>
					<p class="tw-m-0">{{ skill.description }}</p>
				</div>
			</div>
			<div class="tw-text-center tw-pt-6">
				<p-button type="black" @click="close()">Cerrar</p-button>
				<p-button :disabled="!selectedOptions.length" type="secondary" @click="handleSave()"
					>Guardar</p-button
				>
			</div>
		</p-card>
	</v-dialog>
</template>
<script>
import { find, head, pathOr, pipe, prop, propEq } from 'ramda';
import PButton from '@/modules/shared/components/ui/p-button';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import { removeElementInList } from '@/modules/shared/utils/listElements';
import { CHOOSE_SKILLS_MESSAGE } from '@/modules/three-sixty-evaluation/constants/messages.constants';

export default {
	components: { PCard, PButton },
	name: 'SkillSelectionDialog',
	data() {
		return {
			isVisible: false,
			selectedOptions: [],
			selectedSkillGroupId: null,
			selectedSkillGroup: {},
			checkBoxModel: {},
		};
	},
	props: {
		skills: {
			default: [],
		},
	},
	methods: {
		CHOOSE_SKILLS_MESSAGE() {
			return CHOOSE_SKILLS_MESSAGE;
		},
		pathOr,
		open() {
			this.selectedSkillGroupId = pipe(head, prop('id'))(this.skills) || null; // default the first element selected
			this.selectedOptions = [];
			this.checkBoxModel = {};
			this.isVisible = true;
		},
		close() {
			this.isVisible = false;
		},
		handleSave() {
			this.$emit('onSave', this.selectedOptions);
		},
		isChecked(skillItem) {
			return this.selectedOptions.includes(skillItem);
		},
		onCheckChange(checked, option) {
			if (checked) {
				this.selectedOptions = [...this.selectedOptions, option];
			} else {
				this.selectedOptions = removeElementInList(option, this.selectedOptions);
			}
		},
	},
	watch: {
		selectedSkillGroupId(groupId) {
			this.selectedSkillGroup = find(propEq('id', groupId), this.skills);
		},
	},
};
</script>

<style lang="scss" scoped>
.skill-selection {
	p {
		color: var(--app-color-font-gray);
	}
	.skill-title {
		background-color: var(--app-color-primary);
		border-radius: 5px;
	}
	.skill-table {
		height: 40vh;
		overflow: auto;
		&--row {
			display: flex;
			border-top: 0.5px solid var(--app-color-gray);
			border-bottom: 0.5px solid var(--app-color-gray);
			padding: 10px 0 10px;
			& > :nth-child(1) {
				text-align: center;
				width: 10%;
			}
			& > :nth-child(2) {
				width: 30%;
			}
			& > :nth-child(3) {
				width: 60%;
			}

			// overriding custom checkbox style
			.custom-checkbox {
				margin: 0 !important;
				display: flex !important;
				justify-content: center !important;
				padding: 0 !important;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-profile/components/fifth-step/skill-selection-dialog.vue